'use strict';

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 * @param {Object} [options] 可选参数，支持 runWhen 和 priority
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(
  fulfilled,
  rejected,
  options = {}
) {
  const runWhen = options.runWhen || (() => true);
  const priority = options.priority || 0;
  const handler = {
    fulfilled: fulfilled,
    rejected: rejected,
    priority,
    runWhen
  };
  this.handlers.push(handler);
  // 添加调试信息
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.each = function each(fn) {
  this.handlers
    .slice()
    .sort((a, b) => (b.priority || 0) - (a.priority || 0))
    .forEach((h) => {
      if (h !== null) {
        fn(h);
      }
    });
};

export default InterceptorManager;
